import { Component } from '../Component'
import { element } from '../CustomElement'
import { SeoService } from '../../services/SeoService'
import { LocationService } from '../../services/LocationService'
import { inject } from '../../services/di'
import { SeoDataService } from '../../services/SeoDataService'

@element('flipp-city-footer-links')
export class FlippCitiesFooterLinks extends Component<any, any> {
    @inject seoService: SeoService
    @inject locationService: LocationService
    @inject seoDataService: SeoDataService

    render() {
        const locale = this.seoService.locale
        const toLinks = (cityObj: any) => {
            const { name: city, state } = cityObj
            const href =
                `${locale}/${city.replace(' ', '-')}-${state}`.toLowerCase()
            return (
                <li>
                    <a href={href}>{city}</a>
                </li>
            )
        }

        const cities = this.seoDataService.getTopCities()
        return (
            <ul>
                {cities.map(toLinks)}
                <li>
                    <a href={`/${locale}/browser`}>Location Browser</a>
                </li>
                <li>
                    <a href={`/${locale}/categories`}>Categories Browser</a>
                </li>
            </ul>
        )
    }
}
